<script setup>
    import { storeToRefs } from 'pinia';
    import { useUserStore } from "@/store/modules/user";
    import config from "@/config";

    const userStore 	= useUserStore();
    const { isLogin,user } = storeToRefs(userStore);

    const URL = config.base_url.replace("/homeapi","");

    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
    const getContentImage = (value,type=1)=>{
        let defaultImage = URL + '/static/images/menu/empty.png';
        if(value == undefined){
            return defaultImage;
        }

        if(value.image != undefined && value.image.length > 0 && type == 1) {
            return value.image;
        }else if(value.avatar != undefined && value.avatar.length > 0 && type == 2){
            return value.avatar;
        }else if(value.icon != undefined && value.icon.length > 0 && type == 3){
            return value.icon;
        }

        return defaultImage;
    }

    const panel = ref(false);
    const navList = ref([]);
    const showDetail = (index)=>{
        panel.value = true;
        let data = JSON.parse(JSON.stringify(props.data.data[0].list[index].children));
        for(let i=0; i<data.length; i++){
            let result = data[i];
            if(result.list[0] != undefined){
                data[i].title = result.list[0].title;
                data[i].link = result.list[0].link;
                if(result.list[1] != undefined){
                    data[i].list = result.list.slice(1);
                }
            }
        }

        navList.value = data;
    }

    const isLoading = ref(true);
    watch(()=>props.data,(newValue,oldValue)=>{
        isLoading.value = false;
    },{ deep: true, immediate: true });
</script>

<template>
    <div class="category-wrap">
        <el-skeleton :loading="isLoading" animated>
            <template #template>
                <div style="width: 100%; height: 445px; display: flex; justify-content: space-between;">
                    <el-skeleton-item variant="h3" style="width: 250px; height: 445px; border-radius: 15px; background-color: #f2f2f2;" />
                    <el-skeleton-item variant="h3" style="width: 675px; height: 445px; border-radius: 15px; overflow: hidden;" />
                    <el-skeleton-item variant="h3" style="width: 250px; height: 445px; border-radius: 15px; background-color: #f2f2f2; overflow: hidden;" />
                </div>
            </template>
            <template #default>
                <div class="menu" @mouseenter="panel = true" @mouseleave="panel = false">
                    <ul v-if="props.data.data[0] != undefined">
                        <li v-for="(item,index) in props.data.data[0].list" :key="index" @mouseenter="showDetail(index)">
                            <span v-if="item.icon.length > 0 && props.data.data[0].is_icon" class="icon"><img :src="getContentImage(item,3)"></span>
                            <template v-for="(value,idx) in item.list" :key="idx">
                                <a-link :to="value.link.path"><span class="side-box">{{ value.title }}</span></a-link>
                                <span class="side-slash" v-if="item.list.length != (idx+1)">/</span>
                            </template>
                        </li>
                    </ul>
                    <div :style="{ display: panel && navList.length > 0 ? 'block' : 'none' }" class="menu-children-box" @mouseenter="panel = true" @mouseleave="panel = false">
                        <el-scrollbar height="445px">
                            <div class="nav-box" v-for="(item,index) in navList" :key="index">
                                <div class="nav-title">
                                    <span>
                                        <a-link :to="item.link.path">{{ item.title }}</a-link>
                                    </span>
                                    <el-icon class="nav-icon" color="#555"><ArrowRight /></el-icon>
                                </div>
                                <div class="nav-children">
                                    <span v-for="(value,idx) in item.list" :key="idx">
                                        <a-link :to="value.link.path">{{ value.title }}</a-link>
                                    </span>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="banner">
                    <el-carousel height="445px" v-if="props.data.data[1] != undefined">
                        <el-carousel-item v-for="(item,index) in props.data.data[1].list" :key="index">
                            <a-link :to="item.link.path"><img :src="getContentImage(item)" /></a-link>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="ucenter">
                    <div class="avatar-box">
                        <div class="avatar">
                            <img v-if="!isLogin" :src="getContentImage(props.data.data[2],2)" />
                            <img v-else-if="user != null" :src="user.avatar" />
                        </div>
                        <div class="user">
                            <span v-if="props.data.data[2] != undefined">{{ props.data.data[2].tips }}</span>
                            <span v-else>{{ $t("components.design.category.welcome") }}</span>
                            <span v-if="!isLogin"><a-link to="/user/register">{{ $t("components.design.category.sign_up") }}</a-link>/<a-link to="/user/login">{{ $t("components.design.category.sign_in") }}</a-link></span>
                            <span v-if="user != null">{{ user.username }}</span>
                        </div>
                    </div>
                    <template v-if="!isLogin">
                        <div class="tips">
                            <span>{{ $t("components.design.category.tips1") }}</span>
                            <span>{{ $t("components.design.category.tips2") }}</span>
                        </div>
                        <div class="login">
                            <span><a-link to="/user/login">{{ $t("components.design.category.sign_in") }}</a-link></span>
                        </div>
                    </template>
                    <div class="grid-list" v-if="props.data.data[2] != undefined">
                        <div class="grid-box" v-for="(item,index) in props.data.data[2].list" :key="index">
                            <span><a-link :to="item.link.path"><img :src="item.image" /></a-link></span>
                            <span><a-link :to="item.link.path">{{ item.title }}</a-link></span>
                        </div>
                    </div>

                    <div class="promotion-box" v-if="props.data.data[2] != undefined && isLogin">
                        <a-link :to="props.data.data[2].link.path"><img :src="props.data.data[2].image" /></a-link>
                    </div>
                </div>
            </template>
        </el-skeleton>
    </div>
</template>

<style lang="scss" scoped>
.category-wrap {
    width: 1200px;
    height: 445px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 100;
    .menu {
        width: 250px;
        height: 445px;
        border-radius: 15px;
        background-color: #f2f2f2;
        position: relative;
        z-index: 100000;
        .menu-children-box {
            display: none;
            position: absolute;
            z-index: 100001;
            left: 240px;
            top: 0;
            width: 700px;
            height: 445px;
            background-color: #f2f2f2;
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
            .nav-box {
                display: flex;
                flex-direction: row;
                margin-top: 10px;
                .nav-title {
                    font-weight: bold;
                    font-size: 13px;
                    cursor: pointer;
                    color: #555;
                    width: 90px;
                    line-height: 25px;
                    padding-left: 15px;
                    display: inline-block;
                    display: flex;
                    justify-content: space-between;
                    span {
                        width: 80px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: inline-block;
                        overflow: hidden;
                        a {
                            font-weight: bold;
                            color: #555;
                            font-size: 12px;
                            &:hover {
                                color: #ff0000;
                            }
                        }
                    }
                    .nav-icon {
                        position: relative;
                        top: 6px;
                        margin-left: 5px;
                    }
                }
                .nav-children {
                    line-height: 25px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    width: 570px;
                    position: relative;
                    top: 2px;
                    margin-left: 15px;
                    span {
                        margin: 3px 0;
                        padding: 0 5px;
                        height: 16px;
                        line-height: 16px;
                        white-space: nowrap;
                        color: #555;
                        font-size: 12px;
                        margin-right: 5px;
                        a {
                            color: #555;
                            font-size: 12px;
                            &:hover {
                                color: #ff0000;
                            }
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        ul {
            margin-top: 15px;
            margin-left: 25px;
            li {
                display: inline-flex;
                font-size: 14px;
                color: #333;
                height: 40px;
                line-height: 40px;
                width: 210px;
                a {
                    color: #333;
                    text-decoration: none;
                    font-size: 14px;
                    &:hover {
                        color: #dc143c;
                    }
                }
                span {
                    &.icon {
                        width: 20px;
                        height: 20px;
                        position: relative;
                        top: 5px;
                        left: -5px;
                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                    &.side-slash {
                        padding: 0 3px;
                    }
                }
            }
        }
    }
    .banner {
        width: 675px;
        height: 445px;
        border-radius: 15px;
        overflow: hidden;
        img {
            width: 675px;
            height: 445px;
        }
    }
    .ucenter {
        width: 250px;
        height: 445px;
        border-radius: 15px;
        background-color: #f2f2f2;
        overflow: hidden;
        .avatar-box {
            display: flex;
            flex-direction: row;
            margin-top: 30px;
            margin-bottom: 15px;
            .avatar {
                margin-left: 30px;
                img {
                    width: 65px;
                    height: 65px;
                    border-radius: 50%;
                }
            }
            .user {
                margin-left: 12px;
                span {
                    display: block;
                    color: #000;
                    a {
                        color: #000;
                        text-decoration: none;
                        &:hover {
                            color: red;
                        }
                    }
                    &:first-child {
                        font-size: 17px;
                        margin-top: 15px;
                        margin-bottom: 6px;
                    }
                    &:last-child {
                        font-size: 14px;
                    }
                }
            }
        }
        .tips {
            span {
                display: block;
                font-size: 13px;
                color: #666;
                text-align: center;
                margin-bottom: 12px;
                letter-spacing: 1px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            margin-bottom: 16px;
        }
        .login {
            margin-left: 12px;
            width: 225px;
            height: 43px;
            line-height: 43px;
            background-color: #dc143c;
            text-align: center;
            border-radius: 10px;
            span {
                font-size: 16px;
                color: #fff;
                letter-spacing: 5px;
                cursor: pointer;
                a {
                    font-size: 16px;
                    color: #fff;
                    display: block;
                    text-decoration: none;
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
        .promotion-box {
            display: flex;
            width: 100%;
            justify-content: center;
            margin-top: 10px;
            img {
                border-radius: 10px;
                width: 225px;
                height: 95px;
            }
        }
        .grid-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 0 15px;
            margin-top: 10px;
            .grid-box {
                width: 33.333%;
                height: 70px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                span {
                    display: block;
                    text-align: center;
                    a {
                        color: #333;
                        text-decoration: none;
                        font-size: 13px;
                        &:hover {
                            color: #dc143c;
                        }
                    }
                    &:first-child {
                        img {
                            width: 30px;
                            height: 30px;
                        }
                    }
                    &:last-child {
                        font-size: 13px;
                        color: #666;
                        margin-top: 2px;
                    }
                }
            }
        }
    }
}
</style>